var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 64 64",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button_22_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m60 0h-56c-2.209 0-4 1.791-4 4.001v55.999c0 2.21 1.791 4 4 4h56c2.21 0 4-1.79 4-4v-55.999c0-2.21-1.79-4.001-4-4.001z",
    fill: "#07b25c"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_9_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m41.414 28.586-8-8c-.362-.362-.862-.586-1.414-.586-.553 0-1.053.224-1.414.586l-8 8c-.362.362-.586.861-.586 1.414 0 1.104.896 2 2 2 .552 0 1.052-.224 1.414-.586l4.604-4.604v15.19c0 1.105.887 2 1.981 2s1.982-.895 1.982-2v-15.19l4.604 4.604c.362.362.862.586 1.415.586 1.104 0 2-.896 2-2 0-.553-.225-1.052-.586-1.414z",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b404e2c1ab9e82a4e20d48ad736437d3.svg";
export { ForwardRef as ReactComponent };